export const capitalizeFirstLetter = (s) => s && s[0].toUpperCase() + s.slice(1);
export const lowerCaseFirstLetter = (s) => s && s[0].toLowerCase() + s.slice(1);
